import { useCallback, useEffect, useState } from 'react';

import { useAuthInfo } from '@/allauth_auth/hooks';
import { useOrg } from '@/contexts/OrgContext';
import type { AiActionsView } from '@/lib/localStorage/aiActionsSortPrefs';
import {
  getAiActionsViewPref,
  setAiActionsViewPref,
} from '@/lib/localStorage/aiActionsSortPrefs';

// NOTE: useAiActionsSortPref was retired 2026-09-02 with the Priority/Date
// sort toggle — every AI Actions surface now renders priority groups with
// newest-first inside (groupProposalsByTier).

export function useAiActionsViewPref(): [
  AiActionsView,
  (next: AiActionsView) => void,
] {
  const { user } = useAuthInfo();
  const { currentOrg } = useOrg();
  const userId = user?.id;
  const orgId = currentOrg?.id;

  const [value, setValue] = useState<AiActionsView>(() =>
    getAiActionsViewPref(userId, orgId)
  );

  useEffect(() => {
    setValue(getAiActionsViewPref(userId, orgId));
  }, [userId, orgId]);

  const updateValue = useCallback(
    (next: AiActionsView) => {
      if (userId != null && orgId != null) {
        setAiActionsViewPref(userId, orgId, next);
      }
      setValue(next);
    },
    [userId, orgId]
  );

  return [value, updateValue] as const;
}
